// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { notesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes";
import { orderInfoStyles } from "@plumberssupply/App/WidgetExtensions/MyAccountPagesSharedStyles/OrderInformationStyle";
import { xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

notesStyles.wrapper = {
    css: css`
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        width: auto;
        > span {
            font-size: 14px;
        }
        ${xScreen("lte", "sm")} {
            max-width: 100%;
        }
    `,
};

notesStyles.titleText = orderInfoStyles.orderTitle;

notesStyles.notesText = orderInfoStyles.orderValue;
